module.exports = __webpack_public_path__ + "Krompach.jpg?e08f1ab6b7edd1348ba0213beaa62750";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/Krompach.jpg
// module id = 223
// module chunks = 0